var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { YandexGames } from './YandexGames';
import bridge from '@vkontakte/vk-bridge';
import { Logger } from '../classes';
var log = Logger.get('SDK:AUTH', true).log;
var PLATFORM;
(function (PLATFORM) {
    PLATFORM["VK"] = "vk";
    PLATFORM["YANDEX"] = "yandex";
    // OK = 'ok',
})(PLATFORM || (PLATFORM = {}));
var ERRORS;
(function (ERRORS) {
    ERRORS["NOT_AUTH"] = "not auth";
})(ERRORS || (ERRORS = {}));
var Auth = /** @class */ (function () {
    function Auth() {
    }
    Auth.check = function () {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 2];
                        return [4 /*yield*/, YandexGames.getPlayer({ scopes: false }, true)];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.getMode() !== 'lite'];
                    case 2:
                        if (FOR_VK) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    Auth.checkSafe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Auth.check()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        log('checkSafe', err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    Auth.authSafe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, YandexGames.openAuthDialog()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        err_2 = _a.sent();
                        log(err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    Auth.getProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var player, _a, first_name, last_name, photo_100;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 2];
                        return [4 /*yield*/, YandexGames.getPlayer({ scopes: false }, true)];
                    case 1:
                        player = _b.sent();
                        return [2 /*return*/, { name: player.getName(), avatar: player.getPhoto('small') }];
                    case 2:
                        if (!FOR_VK) return [3 /*break*/, 4];
                        return [4 /*yield*/, bridge.send('VKWebAppGetUserInfo', {})];
                    case 3:
                        _a = _b.sent(), first_name = _a.first_name, last_name = _a.last_name, photo_100 = _a.photo_100;
                        return [2 /*return*/, { name: "".concat(first_name, " ").concat(last_name), avatar: photo_100 }];
                    case 4: return [2 /*return*/, { name: '', avatar: '' }];
                }
            });
        });
    };
    Auth.getUid = function () {
        return __awaiter(this, void 0, void 0, function () {
            var search;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 2];
                        _a = {};
                        return [4 /*yield*/, YandexGames.getPlayerId()];
                    case 1: return [2 /*return*/, (_a.externalId = _b.sent(), _a.provider = PLATFORM.YANDEX, _a)];
                    case 2:
                        if (FOR_VK) {
                            search = getSearch();
                            if (search.has('viewer_id')) {
                                return [2 /*return*/, { externalId: search.get('viewer_id'), provider: PLATFORM.VK }];
                            }
                            else {
                                if (DEVELOPMENT) {
                                    return [2 /*return*/, { externalId: 'developer', provider: PLATFORM.VK }];
                                }
                                throw { msg: ERRORS.NOT_AUTH };
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Auth;
}());
export { Auth };
export function getSearchParam(name) {
    var search = getSearch();
    return search.has(name) ? search.get(name) : '';
}
function getSearch() {
    return new URLSearchParams(location.search);
}
